/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { onboardingStepsSchema } from '../enums/onboarding-steps-schema';

export const getPreferencesResponseDataSchema = z.object({
  primaryLanguage: z.string().nullable(),
  detectiveMode: z.boolean(),
  proficiencyScore: z.number(),
  onboarding: onboardingStepsSchema.optional(),
});

export type IGetPreferencesResponseData = z.infer<typeof getPreferencesResponseDataSchema>;

export const getPreferencesResponseSchema = createApiResponseSchema(
  getPreferencesResponseDataSchema,
) as z.ZodSchema<IAPI<IGetPreferencesResponseData>>;

export type IGetPreferencesResponse = IAPI<IGetPreferencesResponseData>;
